/* GENERATED by scripts/gen-data.mjs — chapter "tooling" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_TOOLING: NodeDef = {
  "id": "tooling",
  "tagKey": "path:tooling.tag",
  "x": 600,
  "y": 300,
  "w": 220,
  "h": 116,
  "titleKey": "path:tooling.title",
  "subKey": "path:tooling.sub",
  "blocks": [
    {
      "id": "tooling.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:tooling.b1.title",
      "bodyKey": "path:tooling.b1.body",
      "flowKey": "path:tooling.b1.flow",
      "read": [
        "react"
      ]
    },
    {
      "id": "tooling.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:tooling.b2.title",
      "film": "f-tooling"
    },
    {
      "id": "tooling.b3o",
      "kind": "options",
      "xp": 20,
      "titleKey": "path:tooling.b3o.title",
      "opts": {
        "list": [
          {
            "nKey": "path:tooling.b3o.opts.0.n",
            "wKey": "path:tooling.b3o.opts.0.w",
            "uKey": "path:tooling.b3o.opts.0.u",
            "cKey": "path:tooling.b3o.opts.0.c",
            "slug": "written-by-hand"
          },
          {
            "nKey": "path:tooling.b3o.opts.1.n",
            "wKey": "path:tooling.b3o.opts.1.w",
            "uKey": "path:tooling.b3o.opts.1.u",
            "cKey": "path:tooling.b3o.opts.1.c",
            "slug": "inline-completion"
          },
          {
            "nKey": "path:tooling.b3o.opts.2.n",
            "wKey": "path:tooling.b3o.opts.2.w",
            "uKey": "path:tooling.b3o.opts.2.u",
            "cKey": "path:tooling.b3o.opts.2.c",
            "slug": "agent-runtime-with-tools"
          },
          {
            "nKey": "path:tooling.b3o.opts.3.n",
            "wKey": "path:tooling.b3o.opts.3.w",
            "uKey": "path:tooling.b3o.opts.3.u",
            "cKey": "path:tooling.b3o.opts.3.c",
            "slug": "design-system-bound-as-tokens"
          },
          {
            "nKey": "path:tooling.b3o.opts.4.n",
            "wKey": "path:tooling.b3o.opts.4.w",
            "uKey": "path:tooling.b3o.opts.4.u",
            "cKey": "path:tooling.b3o.opts.4.c",
            "slug": "checks-in-the-pipeline"
          }
        ],
        "ref": "react"
      }
    },
    {
      "id": "tooling.b3",
      "kind": "tree",
      "xp": 20,
      "titleKey": "path:tooling.b3.title",
      "tree": {
        "qKey": "path:tooling.b3.tree.q",
        "branches": [
          {
            "tone": "stop",
            "aKey": "path:tooling.b3.tree.b.0.a",
            "verdictKey": "path:tooling.b3.tree.b.0.verdict"
          },
          {
            "tone": "warn",
            "aKey": "path:tooling.b3.tree.b.1.a",
            "then": {
              "qKey": "path:tooling.b3.tree.b.1.then.q",
              "branches": [
                {
                  "tone": "pass",
                  "aKey": "path:tooling.b3.tree.b.1.then.b.0.a",
                  "verdictKey": "path:tooling.b3.tree.b.1.then.b.0.verdict"
                },
                {
                  "tone": "stop",
                  "aKey": "path:tooling.b3.tree.b.1.then.b.1.a",
                  "verdictKey": "path:tooling.b3.tree.b.1.then.b.1.verdict"
                }
              ]
            }
          },
          {
            "tone": "warn",
            "aKey": "path:tooling.b3.tree.b.2.a",
            "verdictKey": "path:tooling.b3.tree.b.2.verdict"
          }
        ]
      }
    },
    {
      "id": "tooling.b4",
      "kind": "check",
      "xp": 45,
      "titleKey": "path:tooling.b4.title",
      "ex": {
        "type": "classify",
        "binsKey": "path:tooling.b4.ex.bins",
        "binCount": 3,
        "items": [
          {
            "tKey": "path:tooling.b4.ex.items.0.t",
            "bin": 0,
            "whyKey": "path:tooling.b4.ex.items.0.why"
          },
          {
            "tKey": "path:tooling.b4.ex.items.1.t",
            "bin": 1,
            "whyKey": "path:tooling.b4.ex.items.1.why"
          },
          {
            "tKey": "path:tooling.b4.ex.items.2.t",
            "bin": 2,
            "whyKey": "path:tooling.b4.ex.items.2.why"
          }
        ]
      }
    }
  ]
};
